import { gql } from '@apollo/client';

export const GET_OPTION_QUERIES_LIST = gql`
  query OptionQueries($params: FindOptionQueryListInput!) {
    optionQueries(params: $params) {
      success
      message
      errors
      data {
        queries {
          id
          queryKey
          description
          sql
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_OPTION_QUERY = gql`
  query OptionQuery($params: FindOptionQueryInput!) {
    optionQuery(params: $params) {
      success
      message
      errors
      data {
        id
        queryKey
        description
        sql
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
